"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require("@angular/core");
var ladda_config_1 = require("./ladda-config");
var Ladda = require("ladda");
var LaddaDirective = (function () {
    function LaddaDirective(el, config) {
        this.el = el.nativeElement;
        if (!config) {
            return;
        }
        // apply default styles if they aren't overwritten by an attribute
        for (var attribute in ladda_config_1.configAttributes) {
            var configValue = config[ladda_config_1.configAttributes[attribute]];
            if (!configValue) {
                continue; // don't waste time reading the attribute
            }
            if (!this.el.getAttribute(attribute)) {
                // attribute isn't set - apply the default config value
                var value = (typeof configValue === "number") ? configValue.toString() : configValue;
                this.el.setAttribute(attribute, value);
            }
        }
    }
    LaddaDirective.prototype.ngOnChanges = function (changes) {
        if (!this._ladda) {
            return; // needed since ngOnChanges is called before ngOnInit
        }
        if (changes['loading']) {
            this.updateLadda(changes['loading'].previousValue);
        }
        if (changes['disabled']) {
            this.updateDisabled();
        }
    };
    LaddaDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._ladda = Ladda.create(this.el);
        // if the initial loading value isn't false, a timeout of 0 ms
        // is necessary for the calculated spinner size to be correct.
        setTimeout(function () { _this.updateLadda(false); }, 0);
    };
    LaddaDirective.prototype.ngOnDestroy = function () {
        this._ladda.remove();
    };
    LaddaDirective.prototype.updateLadda = function (previousValue) {
        if (this.loading === false) {
            if (previousValue !== false) {
                this._ladda.stop();
            }
            return this.updateDisabled();
        }
        if (previousValue === false) {
            this._ladda.start();
        }
        if (typeof this.loading === 'number') {
            this._ladda.setProgress(this.loading);
        }
    };
    LaddaDirective.prototype.updateDisabled = function () {
        if (this.disabled) {
            this.el.setAttribute('disabled', '');
        }
        else {
            this.el.removeAttribute('disabled');
        }
    };
    return LaddaDirective;
}());
__decorate([
    core_1.Input('ladda'),
    __metadata("design:type", Object)
], LaddaDirective.prototype, "loading", void 0);
__decorate([
    core_1.Input('disabled'),
    __metadata("design:type", Boolean)
], LaddaDirective.prototype, "disabled", void 0);
LaddaDirective = __decorate([
    core_1.Directive({
        selector: '[ladda]'
    }),
    __param(1, core_1.Inject(ladda_config_1.LaddaConfig)), __param(1, core_1.Optional()),
    __metadata("design:paramtypes", [core_1.ElementRef, ladda_config_1.LaddaConfigArgs])
], LaddaDirective);
exports.LaddaDirective = LaddaDirective;
//# sourceMappingURL=ladda.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-ladda/module/ladda.directive.js
// module id = 582
// module chunks = 7